import { render } from "./EventList.vue?vue&type=template&id=03a6ddda&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"

import "./EventList.vue?vue&type=style&index=0&id=03a6ddda&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03a6ddda"

export default script